var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.468 17.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(7902.37 -3940.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_",
    transform: "translate(-7902.37 3941.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_907_",
    d: "M97.568,48.839H86.994A1.293,1.293,0,0,1,85.7,47.544V32.794A1.293,1.293,0,0,1,86.994,31.5H97.568a1.293,1.293,0,0,1,1.294,1.294v14.75A1.293,1.293,0,0,1,97.568,48.839Z",
    transform: "translate(-85.7 -31.5)",
    fill: "#5850d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_906_",
    d: "M98.8,59.66V45.282a.98.98,0,0,1,.982-.982h10.171a.98.98,0,0,1,.982.982V59.66a.98.98,0,0,1-.982.981H99.782A.985.985,0,0,1,98.8,59.66Z",
    transform: "translate(-98.288 -43.799)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    d: "M198.716,30.366V26.471L193.3,21.2h-4Z",
    transform: "translate(-8087.618 3919.695)",
    fill: "#453eae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_904_",
    d: "M189.3,21.2v.4h.415Z",
    transform: "translate(-8087.618 3919.695)",
    fill: "#363274"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    d: "M422.3,248v.3h.3Z",
    transform: "translate(-8311.508 3701.764)",
    fill: "#363274"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M-1.35-2.445h-.887V0h-.49V-2.445h-.879v-.4H-1.35ZM0-1.816.6-2.844h.57L.311-1.434,1.189,0H.613L0-1.043-.611,0h-.574L-.3-1.434l-.861-1.41H-.6Zm3.607-.629H2.723V0h-.49V-2.445H1.354v-.4H3.609Z",
    transform: "translate(-7895.789 3955)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFile);
export default __webpack_public_path__ + "static/media/textFile.189c7b7e069103099cfe5970075e994a.svg";
export { ForwardRef as ReactComponent };